import { render, staticRenderFns } from "./foundersPlayers.vue?vue&type=template&id=46ed0ed5&scoped=true"
import script from "./foundersPlayers.vue?vue&type=script&lang=js"
export * from "./foundersPlayers.vue?vue&type=script&lang=js"
import style0 from "./foundersPlayers.vue?vue&type=style&index=0&id=46ed0ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed0ed5",
  null
  
)

export default component.exports